var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Alert",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#f79818"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "priority_high_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24",
    d: "M403.692-806.774a3.555,3.555,0,0,1-2.607-1.084A3.555,3.555,0,0,1,400-810.466a3.555,3.555,0,0,1,1.084-2.607,3.555,3.555,0,0,1,2.607-1.084,3.555,3.555,0,0,1,2.607,1.084,3.555,3.555,0,0,1,1.084,2.607,3.555,3.555,0,0,1-1.084,2.607A3.555,3.555,0,0,1,403.692-806.774Zm0-11.075a3.555,3.555,0,0,1-2.607-1.084A3.555,3.555,0,0,1,400-821.541v-14.767a3.555,3.555,0,0,1,1.084-2.607A3.555,3.555,0,0,1,403.692-840a3.555,3.555,0,0,1,2.607,1.084,3.555,3.555,0,0,1,1.084,2.607v14.767a3.555,3.555,0,0,1-1.084,2.607A3.555,3.555,0,0,1,403.692-817.85Z",
    transform: "translate(-374 853)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.cd3285501d74155b00b5e4ff8aa672c7.svg";
export { ForwardRef as ReactComponent };